import mitt, { Emitter } from "mitt";

type Events = {
  [key: string]: unknown;
};

const emitter: Emitter<Events> = mitt<Events>();

export const on = emitter.on.bind(emitter);
export const emit = emitter.emit.bind(emitter);
export const all = emitter.all;

export default {
  all,
  on,
  emit,
};
